export default __webpack_public_path__ + "static/media/m_cycles1.442e038f.png";